import { Box, Grid, Typography } from '@mui/material';
import { useContext, useEffect } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import InputConfig from '../../../../../Components/InputConfig';
import { CONFIG_KEYS } from '../../../../../core/constants';
import InfoButton from '../../../../../Components/InfoButton';
import { FEATURE_DESCRIPTION } from '../../../constant';

const BackPocketAdDelaySection = ({ keyData }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const { AGGRESSIVE_AD_REQ_ENABLED } = CONFIG_KEYS;
	const aggressiveAdRequestsEnabled = rawConfig[AGGRESSIVE_AD_REQ_ENABLED] || false;
	const { REQUEST_STRUCTURE_DATA } = FEATURE_DESCRIPTION;

	useEffect(() => {
		if (!aggressiveAdRequestsEnabled && rawConfig[`${keyData}.enabled`]) {
			const cloneRawConfig = structuredClone(rawConfig);
			cloneRawConfig[`${keyData}.enabled`] = false;
			updateRawConfig(cloneRawConfig);
		}
	}, [aggressiveAdRequestsEnabled]);

	return (
		<Grid item>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'flex-start',
					mb: 1.5,
					flexDirection: 'column',
					gap: '1rem'
				}}
			>
				<Typography variant="h6" sx={{ fontWeight: 600, mr: 2 }}>
					Subsequent Ad Requests Delay Config
					<InfoButton message={REQUEST_STRUCTURE_DATA.SUBSEQUENT_AD_REQUEST_DELAY_CONFIG} />
				</Typography>
			</Box>

			<Grid container spacing={2} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
				<Grid item>
					<CheckBoxInput
						keyData={`${keyData}.enabled`}
						label="Enabled"
						disabled={!aggressiveAdRequestsEnabled}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item sx={{ ml: '2rem' }}>
					<InputConfig
						label="Ad Start Delay (Ms)"
						keyData={`${keyData}.adStartDelayTimeInMs`}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputProps={{ min: 0 }}
						editable={!!rawConfig[`${keyData}.enabled`] && aggressiveAdRequestsEnabled}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default BackPocketAdDelaySection;
